import {useMemo, useState, useEffect, useRef} from 'react';
import './App.css';
import background from './bg_land.png';
import btnAppLink from './btn_applink.png';
import imgShare from './share.png';

const getMobileOS = () => {
  const ua = navigator.userAgent
  const isAndroid = /android/i;
  const isIOs = /iPad|iPhone|iPod/;
  
  if (isAndroid.test(ua)) {
    return "android"
  }
  else if (isIOs.test(ua) && navigator.maxTouchPoints > 1) {
    return "ios"
  }
  return "PC"
}

const setMetaTags = ({ title="그레이트북스", description="공유된 컨텐츠를 열기위해 앱을 실행하거나 다운로드합니다.", imageUrl=imgShare}) => {
  //set title
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute("content", `${title}`);
      
  //set description
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute("content", description);
      
  //set images
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute("content", imageUrl);
      
  // //set url
  // document
  //   .querySelector('meta[property="og:url"]')
  //   .setAttribute("content", window.location.href);
};

function GoAppLink() {
  return (
      <img
        src={btnAppLink} 
        alt="앱으로 이동" 
        className="link-to"
      />
  );
}

function App() {
  const [url, setUrl] = useState(window.location)
  const [params, setParams] = useState(window.location.search)
  const [os, setOS] = useState("PC")
  const [link, setLink] = useState({})
  const [fullLink, setFullLink] = useState({})

  const [timeLeft, setTimeLeft] = useState(1);
  const interval = useRef();
  const aLinkRef = useRef();

  const links = useMemo(() => {
    const os = getMobileOS();

    setMetaTags({
      title: "",
      description: "",
      imageUrl: "",
    });

    return {
      android: {
        marketUrl: "market://details?id=kr.co.greatbooks.grBooks",
        appUrl: "grbooks://link",
        linkUrl: "https://cms.greatbooks.co.kr/api/link/index.html",
        intentUrl: "intent://link?[param]#Intent;scheme=grbooks;package=kr.co.greatbooks.grBooks;end",
      },
      ios: {
        marketUrl: "https://apps.apple.com/kr/app/%EA%B7%B8%EB%A0%88%EC%9D%B4%ED%8A%B8%EB%B6%81%EC%8A%A4/id1618583288",
        appUrl: "grbooks://link",
        linkUrl: "https://cms.greatbooks.co.kr/api/link/index.html",
      },
      PC: {
        marketUrl: "https://apps.apple.com/kr/app/%EA%B7%B8%EB%A0%88%EC%9D%B4%ED%8A%B8%EB%B6%81%EC%8A%A4/id1618583288",
        appUrl: "grbooks://link",
        linkUrl: "https://cms.greatbooks.co.kr/api/link/index.html",
      },
    }
  }, [])

  useEffect( () => {
    const moOS = getMobileOS()

    setOS(moOS)
    setLink(links[os])

    const fLink = links[os].linkUrl + window.location.search
    setFullLink(fLink)
  }, [])

  useEffect(() => {
    interval.current = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 700);

    return () => clearInterval(interval.current);
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      clearInterval(interval.current);
      if (os === 'android') {
        window.open(fullLink, '_self', 'noreferrer');
      }
    }
  }, [timeLeft]);

  return (
    <div style={{height:'100vh', backgroundImage: `url(${background})`}} className="background">
        <a
          href={fullLink}
          target="_self"
          rel="noopener noreferrer"
          ref={aLinkRef}
        >
          <GoAppLink />
        </a>
    </div>
  );
}

export default App;
